"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const envelope = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-envelope` : '') + (description ? ` desc-envelope` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-envelope"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-envelope"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21 4.75C22.1907 4.75 23.1656 5.67488 23.2448 6.84592L23.25 7V18C23.25 19.1905 22.3244 20.1656 21.154 20.2448L21 20.25H3C1.80955 20.25 0.834389 19.3244 0.755193 18.154L0.75 18V7C0.75 5.80884 1.67531 4.83433 2.84597 4.75519L3 4.75H21ZM21.75 7.159L12.4685 14.5857C12.225 14.7804 11.8905 14.8021 11.6267 14.6506L11.5315 14.5857L2.25 7.16V18C2.25 18.3793 2.53251 18.6934 2.89832 18.7431L3 18.75H21C21.3793 18.75 21.6934 18.4675 21.7431 18.1017L21.75 18V7.159ZM20.486 6.25H3.513L12 13.039L20.486 6.25Z",
    fill: "inherit"
  }));
};
var _default = exports.default = envelope;